<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="400px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="仓库名称:"
        prop="warehouseName">
        <el-input
          v-model="ruleForm.warehouseName"
          :maxlength="16"
          show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import Wms from '@/service/wms'
export default {
  name: 'WarehouseEditModal',
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: { warehouseId: null, warehouseName: '' }, // 菜鸟侧品牌id
      rules: {
        warehouseName: [{ required: true, message: '请输入仓库名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    title({ ruleForm }) {
      return ruleForm.warehouseId ? '修改仓库' : '新增仓库'
    }
  },
  methods: {
    handleClose() {
      this.ruleForm.warehouseId = null
      this.ruleForm.warehouseName = ''
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.ruleForm.warehouseId ? 'updatewarehouse' : 'addwarehouse'
          this.loading = true
          Wms[dispatch]({ ...this.ruleForm })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.visible = false
                this.$message.success('提交成功')
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    init(options = {}) {
      this.ruleForm = { ...this.ruleForm, ...options }
      this.visible = true
    }
  }
}
</script>
